




































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";
import { DataModules } from "@/store/modules/data";
import { IShare } from "@/models/share";
import { IState } from "@/store";
import Context from "@/mixins/context";
import { GuestRoutes } from "@/data/enums/router";

@Component({
  components: {
    "client-container": () => import("@/skeleton/client/clientContainer.vue")
  },
  computed: {
    ...mapState({
      share(state: IState, getters) {
        return getters[`data/single`]({
          storeModule: DataModules.SHARES
        });
      }
    })
  }
})
export default class Share extends Mixins(Context) {
  // Props
  @Prop({ required: true })
  public token!: string;

  // Data
  public share!: IShare;
  public isLoading = true;
  public requestError = false;

  // Lifecycle Methods
  public async mounted() {
    this.isLoading = true;

    await this.$store.dispatch("auth/guest/createToken");
    try {
      await this.getData();
      setTimeout(() => {
        this.isLoading = false;
      }, 1000);
    } catch (error) {
      setTimeout(() => {
        this.requestError = true;
        this.isLoading = false;
        this.$store.dispatch("api/handleError", error);
      }, 1000);
    }
  }

  public beforeDestroy() {
    this.$store.dispatch("data/binSingle", {
      storeModule: DataModules.SHARES,
      vm: this
    });
  }

  // Computed
  public get rootPath() {
    return this.isAdmin ? "/admin" : "/";
  }

  public get routeObjectType() {
    return this.$_.head(this.$route.path.split("/").filter(i => i));
  }

  public get component() {
    if (!this.$_.get(this.share, "actions[0].service")) return null;

    switch (this.share.actions[0].service) {
      case "invoice":
        return {
          component: () => import("@/views/share/invoice/index.vue"),
          props: {
            token: this.token,
            shareObject: this.share,
            invoiceId: this.$_.get(this.share, "object.id")
          }
        };
      default:
        this.$router.push("/");
    }

    return null;
  }

  // Methods
  public refresh() {
    this.requestError = false;
    return this.getData().catch(error => {
      this.$store.dispatch("api/handleValidationError", error);
      this.requestError = true;
    });
  }
  public getData() {
    let payload = {};
    const routeName = this.$route.name;
    if (routeName === GuestRoutes.SHARED_INVOICE)
      payload = {
        params: {
          relations: [
            "client",
            "account.preferred_payment_currency",
            "current_data",
            "payments",
            "promotions",
            "status",
            "taxes",
            "taxes.tax_tag_data"
          ].join()
        }
      };

    return this.$store.dispatch(`data/${DataModules.SHARES}/get`, {
      ignoreStored: true,
      handle401Error: false,
      vm: this,
      token: this.token,
      ...payload
    });
  }
}
